import React from 'react';
import classnames from 'classnames';
import slugify from 'slugify';
import LinkIcon from '../icons/Link';
import Button from './Button';

import './PancakeIntro.scss';

const PancakeIntro = (props) => {
  const textAlign = props.textAlign
    ? `PancakeIntroTextAlign${props.textAlign}`
    : '';
  const slug =
    props.title && slugify(props.title, { lower: true, strict: true });

  return (
    <div className={classnames('PancakeIntro', props.className, textAlign)}>
      {props.title && (
        <h2 className="PancakeIntroTitle" id={slug}>
          <a
            href={`#${slug}`}
            aria-label={`${props.title} permalink`}
            className="HeadingAnchorLink"
          >
            <LinkIcon />
          </a>
          {props.title}
        </h2>
      )}
      {props.text && (
        <p
          className="PancakeIntroText"
          dangerouslySetInnerHTML={{ __html: props.text }}
        />
      )}
      {props.cta && (
        <Button
          className="transparent teal no-padding"
          arrow
          to={props.cta.url}
        >
          {props.cta.label}
        </Button>
      )}
    </div>
  );
};

export default PancakeIntro;
